// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3063":"29d9de76","3133":"3d36e302","3992":"ac0ae5a5","7452":"3ed49279"}[chunkId] + ".chunk.css";
};